import { createElement, Fragment, ReactNode } from "react";

const ALLOWED_DESCRIPTION_TAGS = new Set(["u", "b", "i", "strong"]);

export function renderSafeDescription(input: string): ReactNode {
  if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
    return input;
  }

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(input, "text/html");

  const renderNode = (node: Node, key: string): ReactNode => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? "";
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return null;
    }

    const source = node as Element;
    const tagName = source.tagName.toLowerCase();
    const children = Array.from(source.childNodes).map((child, index) => renderNode(child, `${key}-${index}`));

    if (ALLOWED_DESCRIPTION_TAGS.has(tagName)) {
      return createElement(tagName, { key }, ...children);
    }

    return createElement(Fragment, { key }, ...children);
  };

  return Array.from(doc.body.childNodes).map((child, index) => renderNode(child, `desc-${index}`));
}